import { useTranslation } from 'react-i18next'

import { Checkbox, ComboBox, Divider, Text } from '@reveni-io/reveni-ui'

import BuyXGetYConfiguration from '../BuyXGetYConfiguration/BuyXGetYConfiguration'
import BrokenDiscountCustomMessage from './BrokenDiscountCustomMessage/BrokenDiscountCustomMessage'
import { brokenDiscountHandlingOptions, brokenDiscountHandlingValues } from './constants'
import { getShowBrokenDiscountHandling } from './helpers'
import * as Styles from './styles'

const DiscountsConfiguration = ({
  brokenDiscountHandling,
  setBrokenDiscountHandling,
  allowsBrokenDiscountHandling,
  isUnifiedDashboard,
  buyXGetYReturnPolicy,
  setBuyXGetYReturnPolicy,
  brokenDiscountBonusEnabled,
  setBrokenDiscountBonusEnabled,
  brokenDiscountCustomMessageEnabled,
  setBrokenDiscountCustomMessageEnabled,
  brokenDiscountCustomMessage,
  setBrokenDiscountCustomMessage,
  disabled,
}) => {
  const { t } = useTranslation()

  const showBrokenDiscountHandling = getShowBrokenDiscountHandling({
    isUnifiedDashboard,
    allowsBrokenDiscountHandling,
  })

  const selectedBrokenDiscountOption = brokenDiscountHandlingOptions.find(o => o.value === brokenDiscountHandling)
  const showChargeFeeSettings =
    showBrokenDiscountHandling && brokenDiscountHandling === brokenDiscountHandlingValues.chargeFee

  const handleChangeBrokenDiscountHandling = event => setBrokenDiscountHandling(event.target.value)

  const handleChangeBrokenDiscountFeeRefundEnabled = event => setBrokenDiscountBonusEnabled(event.target.checked)

  if (!showBrokenDiscountHandling && !buyXGetYReturnPolicy) return null

  return (
    <Styles.Container>
      <Divider />
      <Text type="titleM">{t('Descuentos')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define cómo deben gestionarse en el portal los pedidos con descuentos si se rompen las condiciones de elegibilidad.'
        )}
      </Text>
      {showBrokenDiscountHandling && (
        <ComboBox
          label={t('Gestión de descuento roto')}
          menuItems={brokenDiscountHandlingOptions.map(o => ({ ...o, label: t(o.label) }))}
          handleChange={handleChangeBrokenDiscountHandling}
          value={brokenDiscountHandling}
          helperText={t(selectedBrokenDiscountOption.description)}
          disabled={disabled}
        />
      )}
      {showChargeFeeSettings && (
        <Checkbox
          checked={brokenDiscountBonusEnabled}
          onChange={handleChangeBrokenDiscountFeeRefundEnabled}
          label={t('Reembolsar la fee de descuento roto a medida que se devuelvan los productos afectados')}
          disabled={disabled}
        />
      )}
      {showChargeFeeSettings && (
        <BrokenDiscountCustomMessage
          enabled={brokenDiscountCustomMessageEnabled}
          message={brokenDiscountCustomMessage}
          onChangeEnabled={setBrokenDiscountCustomMessageEnabled}
          onChangeMessage={setBrokenDiscountCustomMessage}
          disabled={disabled}
        />
      )}
      <BuyXGetYConfiguration
        buyXGetYReturnPolicy={buyXGetYReturnPolicy}
        setBuyXGetYReturnPolicy={setBuyXGetYReturnPolicy}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default DiscountsConfiguration
